export const enum ErrorName {
  BROWSER_ERROR = "BROWSER_ERROR",
  CACHE_EXPIRED = "CACHE_EXPIRED",
  FILE_NOT_FOUND = "FILE_NOT_FOUND",
  FILE_NOT_PDF = "FILE_NOT_PDF",
  GENERIC_ERROR = "GENERIC_ERROR",
  PERMISSION_ERROR = "PERMISSION_ERROR",
}
